/* A segment ("capo 3, C shapes") stays whole; the line wraps between segments */
.segment {
  white-space: nowrap;
}
